import {
  createExternalRouteRef,
  createRouteRef,
} from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'neo4j-techdocs',
});

export const createTechdocsRootRef = createExternalRouteRef({
  id: 'techdocs-root',
  defaultTarget: 'techdocs.root',
});

export const createTechdocsReaderPageRef = createExternalRouteRef({
  id: 'techdocs-reader-page',
  params: ['namespace', 'kind', 'name'],
  defaultTarget: 'techdocs.docRoot',
});

export const createScaffolderSelectedTemplatePageRef = createExternalRouteRef({
  id: 'scaffolder-execute-page',
  params: ['namespace', 'templateName'],
  defaultTarget: 'scaffolder.selectedTemplate',
});
